import * as DashboardInformationActions from './dashboard-information.actions';
import { DashboardInformation } from './dashboard-information.model';

export interface State {
  userInformation: DashboardInformation;
}

const initialState: State = {
  userInformation: {
    dashboardWelcomeText: '',
    dashboardUsername: '',
    loggedInUser: null
  }
};

export function dashboardInformationReducer(state = initialState, action: DashboardInformationActions.DashboardInformationActions) {
  switch (action.type) {
    case (DashboardInformationActions.Add_DashboardInformation):

      const updatedDashboardInformation = action.payload;


      let updatedDashboardInfo = state.userInformation;
      updatedDashboardInfo = updatedDashboardInformation;

      return {
        ...state,
        userInformation: updatedDashboardInfo
      };

    default:
      return state;
  }
}
